import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Strategic Location",
    body: "Positioned directly at NATO's Eastern Flank for rapid OCONUS response. Operating from Bulgaria places DEFCOIN within hours of key allied installations — including Novo Selo Training Area and Graf Ignatievo Air Base — enabling on-the-ground support where US primes need it most.",
    testid: "advantage-location",
  },
  {
    num: "02",
    title: "Zero-Bureaucracy Agility",
    body: "Fast-track turnarounds for RFQ/RFP requests. As a lean small business, DEFCOIN eliminates the procurement drag typical of larger integrators — quotes, sourcing confirmations, and teaming agreements move at operational tempo.",
    testid: "advantage-agility",
  },
  {
    num: "03",
    title: "Strict EU/US Compliance",
    body: "Full adherence to international defense trade and cross-border data policies. Every transaction is executed within EU export-control frameworks and US federal acquisition requirements — documented, auditable, and clean.",
    testid: "advantage-compliance",
  },
];

export default function WhyDefcoin() {
  return (
    <section id="teaming" className="py-16 md:py-24 lg:py-28 bg-[#0D0F12]" data-testid="why-defcoin-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.7 }}
          className="mb-8 md:mb-14"
        >
          <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-amber-600 mb-3 flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-amber-600" /> 03 / Why DEFCOIN
          </p>
          <h2 className="font-display font-bold uppercase tracking-tight text-xl sm:text-2xl text-slate-50">
            The Strategic Advantage Manifesto
          </h2>
        </motion.div>

        <div className="space-y-0 border-t border-slate-800">
          {CHAPTERS.map((ch, i) => (
            <motion.div
              key={ch.num}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="group grid md:grid-cols-12 gap-4 md:gap-8 py-7 md:py-10 lg:py-12 border-b border-slate-800 items-start"
              data-testid={ch.testid}
            >
              <div className="flex items-baseline gap-4 md:contents">
                <div className="md:col-span-2">
                  <span className="font-mono text-3xl md:text-4xl lg:text-5xl font-medium text-slate-700 md:text-slate-800 group-hover:text-amber-600/80 transition-colors duration-500 leading-none">
                    {ch.num}
                  </span>
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-display font-bold uppercase tracking-tight text-base md:text-lg text-slate-50">
                    {ch.title}
                  </h3>
                </div>
              </div>
              <div className="md:col-span-6">
                <p className="text-sm text-slate-400 leading-relaxed">{ch.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
